type HtmlParsedAnswer = {
    answerHtml: string;
};

export function parseAnswerToHtml(answer: string): HtmlParsedAnswer {
    return {
        answerHtml: answer
    };
}
